import { Component } from '@angular/core';

export interface InicioSesionOpcion {
  id: string;
  imagen: string;
  etiquetaAccesible: string;
  ruta: string;
}

@Component({
  selector: 'app-inicio-sesion',
  templateUrl: './inicio-sesion.component.html',
  styleUrls: ['./inicio-sesion.component.scss'],
  standalone: false,
})
export class InicioSesionComponentCore {
  readonly opciones: InicioSesionOpcion[] = [
    {
      id: 'microempresario',
      imagen: 'assets/img/Inicio_sesion/jpg/im_microempresario.jpg',
      etiquetaAccesible: 'Iniciar sesión como microempresario',
      ruta: '/microempresario/login',
    },
    {
      id: 'aliado-financiero',
      imagen: 'assets/img/Inicio_sesion/jpg/img_aliado_financiero.jpg',
      etiquetaAccesible: 'Iniciar sesión como aliado financiero',
      ruta: '/intermediario/login',
    },
  ];
}
